import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import Pagination from "./Pagination";
import FilterPopup from "../Modals/FilterPopup";
import TransferUser from "../Modals/TransferUser";
import ActivatePopUp from "../Modals/ActivatePopUp";
import { AdminUserDto } from "../../../api/interfaces/addUser";
import { useToaster } from "../../../Toaster/Toaster";
import { useLoader } from "../../../Loader/LoaderContext";
import { postService } from "../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../api";
import {
  getDisplayCompanys,
  getDotColor,
  getRoleDisplayName,
  getStatusClass,
  getStatusDisplayName,
} from "../../../utility/RolesUtility";
import ViewPopup from "../Modals/ViewPopup";

type FilterType = {
  role: string[];
  status: string[];
  leads: string[];
  addedByLeads: number[];
  statusInPosts: string[];
  serviceFilterInPosts: string[];
  featuredTypeFilter: string[];
  postType: string[];
  pitchedBy: number[];
  country: number[];
  types: string[];
};

const Event: React.FC = () => {
  const [message, setMessage] = useState("");
  const [isOpen, showPopup] = useState(false);
  type SortType = {
    column: string;
    direction: number;
  };
  const [sort, setSort] = useState<SortType>({ column: "", direction: 1 });
  const [item, setItem] = useState<AdminUserDto | null>(null);
  const [isDeactivate, setDeactivate] = useState(false);
  const [statusValue, setstatus] = useState("");
  const [isOpenTransfer, setTransfer] = useState(false);
  const { showToast } = useToaster();
  const [tableData, setTableData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState<string>(() => {
    // Initialize from sessionStorage if available
    return sessionStorage.getItem("searchQuery") || "";
  });

  const [searchParams] = useSearchParams();
  const addedBy = searchParams.get("addedBy");
  const addedByName = searchParams.get("addedByName");
  const userRole = searchParams.get("userRole");
  const [totalElement, setTotalElements] = useState(0);
  const [filters, setFilters] = useState<FilterType>({
    role: [],
    status: [],
    leads: [],
    addedByLeads: [],
    statusInPosts: [],
    serviceFilterInPosts: [],
    featuredTypeFilter: [],
    postType: [],
    pitchedBy: [],
    country: [],
    types: [],
  });
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const [isRefreshPage, setisRefreshPage] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const toggleDropdown = (index: number) => {
    setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
  };
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };

  const location = useLocation();
  const path = location.pathname;
  const viewProfile = (data: any) => {
    let nameOfScreen;

    nameOfScreen = "enquiryevents";
    navigate(
      "/portals/enquiries/events/viewDetailsEvents?appUserId=" +
        data?.postId +
        "&name=" +
        nameOfScreen
    );
  };
  useEffect(() => {
    fetchVehicles();

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [currentPage, searchQuery, filters, sort, addedBy, isRefreshPage]);
  const fetchVehicles = async () => {
    setLoading(true);
    let body: any;
    if (addedBy) {
      body = {
        page: currentPage,
        search: searchQuery,
      };
    } else {
      body = {
        page: currentPage,
        search: searchQuery,
      };
    }
    try {
      let url: string = API_ENDPOINTS.getEventEnquiries;

      const response = await postService(url, body);
      setTableData(response.data.content);
      setTotalPages(response.data.totalPages);
      setTotalElements(response.data.totalElements);
    } catch (error) {
      showToast("error", "error", "");
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleEdit = (data: any) => {
    console.log("Edit clicked");
    navigate("/portals/userManagmnt/addUser?appUserId=" + data?.appUserId);
  };
  const handleTransfer = (data: any) => {
    setTransfer(true);
    setItem(data);
  };
  const handleDeactivate = (data: any) => {
    setDeactivate(true);
    setstatus(data);
  };
  const onPageChange = async (page: any) => {
    setCurrentPage(page);
    sessionStorage.setItem("currentPage", page);
  };

  const onNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const handleClosePopups = () => {
    setDeactivate(false);
    setisRefreshPage(true);
  };
  const handleClosePopup = () => setTransfer(false);
  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };
  const addUser = () => {
    navigate("/portals/userManagmnt/addUser");
  };
  const viewTeams = (data: any) => {
    navigate(
      "/portals/userManagmnt/viewUser?addedBy=" +
        data?.appUserId +
        "&addedByName=" +
        data?.firstName +
        "&userRole=" +
        data?.role
    );
    setCurrentPage(0);
    setSearchQuery("");
    setActiveDropdown(null);
  };

  const handleSort = (column: string) => {
    const direction = sort.column === column && sort.direction == 1 ? 0 : 1;
    setSort({ column, direction });
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchQuery = event.target.value;

    // Update state
    setSearchQuery(newSearchQuery);
    setCurrentPage(0);

    // Persist to sessionStorage
    sessionStorage.setItem("searchQuery", newSearchQuery);
    sessionStorage.setItem("currentPage", "0");
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      sessionStorage.removeItem("currentPage");
      sessionStorage.removeItem("searchQuery");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const viewText = (user: any) => {
    setMessage(user?.message);
    showPopup(true);
  };
  const userType = (data: any) => {
    if (data?.userType === "READER") {
      navigate(
        "/portals/enquiries/events/ViewDetails?appUserId=" + data?.appUserId
      );
    } else if (data.userType === "COMPANY") {
      navigate(
        "/portals/enquiries/events/previewCompany?vendorId=" + data?.vendorId
      );
    } else if (data?.userType === "HOSPITAL") {
      navigate(
        "/portals/enquiries/events/previewHospital?vendorId=" + data?.vendorId
      );
    } else if (data.userType === "EVENT_ORGANIZER") {
      navigate(
        "/portals/enquiries/events/eventPreview?vendorId=" + data?.vendorId
      );
    }
  };
  return (
    <div className="h-full py-2 w-full relative">
      <div className="flex items-center mb-3 mt-2 cursor-pointer justify-between">
        <div className="flex items-center">
          <>
            <h1 className="text-2xl font-bold mb-2 text-[#2D2E2F] mr-3">
              Events
            </h1>
            <input
              type="text"
              placeholder="Search"
              className="p-2 border border-[#D1D5DB] w-[300px] rounded-md"
              value={searchQuery}
              onChange={handleSearch}
            />
          </>
        </div>
      </div>
      <div className="overflow-x-auto ">
        <table className="min-w-full bg-white border border-gray-200 ">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky bg-gray-100 left-0 z-10">
                Name
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">
                Email Address
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">
                Country
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">
                Phone Number
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">
                Company Name
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">
                Message
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">
                Received On
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">
                Event Name
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">
                Event End Date
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                {" "}
                User Type
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((user: any, index: number) => (
              <tr key={index}>
                <td className="px-4 py-3 border-b text-sm text-gray-900 font-semibold sticky left-0 bg-white z-10 cursor-pointer whitespace-nowrap">
                  {user.name || "NA"}
                </td>
                <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap">
                  {user.emailAddress || "NA"}
                </td>
                <td className="px-4 py-3 border-b text-sm text-gray-500">
                  {user.mtCountryDto.name || "NA"}
                </td>
                <td className="px-4 py-3 border-b text-sm text-gray-500">
                  {user.phoneNo || "NA"}
                </td>
                <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap">
                  {user.companyName || "NA"}
                </td>
                <td
                  className={`px-4 py-3 border-b text-sm ${
                    user?.message
                      ? "text-blue-500 cursor-pointer"
                      : "text-gray-500"
                  }  `}
                  onClick={() => (user?.message ? viewText(user) : null)}
                >
                  {user?.message ? "View" : "NA"}
                </td>
                <td className="px-4 py-3 border-b text-sm text-gray-500">
                  {user.createdOn || "NA"}
                </td>
                <td
                  className="px-4 py-3 border-b text-sm text-blue-500 cursor-pointer max-w-[250px] truncate whitespace-nowrap overflow-hidden text-ellipsis"
                  onClick={() => viewProfile(user)}
                  // title={user?.message || 'NA'}  // Tooltip on hover
                >
                  {user?.eventName || "NA"}
                </td>

                <td className="px-4 py-3 border-b text-sm text-gray-500">
                  {user.eventEndDate}
                </td>
                <td
                  className={`px-4 py-3 border-b text-sm ${
                    user.userType === "READER" ||
                    user?.userType === "COMPANY" ||
                    user?.userType === "EVENT_ORGANIZER" ||
                    user?.userType === "HOSPITAL"
                      ? "text-blue-500"
                      : "text-gray-500"
                  } cursor-pointer`}
                  onClick={() => userType(user)}
                >
                  {getDisplayCompanys(user.userType) || "Guest"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!tableData.length && (
          <p className="text-center p-2 bg-white">No data to display</p>
        )}

        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalElement={totalElement}
            onPageChange={onPageChange}
            onNext={onNext}
            onPrevious={onPrevious}
          />
        )}
      </div>
      {isOpen && (
        <ViewPopup
          onClose={() => showPopup(false)}
          title="Message"
          body={message}
          closeButtonName="Close"
        />
      )}
    </div>
  );
};

export default Event;
